import styled from 'styled-components';

const DropdownWrap = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 32px;
`;
export default { DropdownWrap };
